import React from 'react';
import { TableCell } from '@material-ui/core';

import { useStyles } from './styles';
import { ITableHeaderCellProps } from './interfaces';

export const TableHeaderCell = <T, K extends keyof T>({ column }: ITableHeaderCellProps<T, K>) => {
  const classes = useStyles({ columnWidth: column?.columnWidth, headerAlign: column?.headerAlign });

  return <TableCell className={classes.tableHeadCell}>{column.header}</TableCell>;
};
